<template lang="pug">
div(class="topbar")
    div(class="title")
        h2.m-0 Announcements
        b-button(class="bg-8967b3" @click="$emit('createAnnouncement')" ) Create Announcement
    div(class="tabs")
        div(v-for="tab in tabs" :key="tab.value" :class="{active: currentTab === tab.value}"
        class="tab" @click="$emit('tabChange', tab.value)") {{tab.name}}
        
        
</template>

<script>
    export default {
        props:{
            currentTab: String
        },
        data(){
            return {
                tabs: [
                    {name: 'Pinned', value: 'pinned'},
                    {name:'Regular', value: 'regular'},
                    {name: 'All', value: 'all'},
                    
                ],
                
            }
        },
        
    }
</script>

<style lang="scss" scoped>
.topbar {
    background-color: white;
    height: 15%;
    border-bottom: 1px solid #eceef2;
    box-shadow: 0 1px 6px rgba(63, 30, 84, 0.05);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: start ;
    width: 100%;
    padding: 20px 40px;
    .title{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        h2 {
            color: #3f1e54;
            font-weight: 700;
        }
        .bg-8967b3 {
        background-color: #50276b;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 8px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s ease;
        &:hover {
            background-color: #3e1f5b;
        }
    }
    }
    .tabs{
        width: 100%;
        display: flex;
        gap: 10px;
        .tab{
            padding: 10px 20px;
            transition: background-color 0.3s ease, color 0.3s ease;
            border-radius: 8px 8px 0 0;
            color: #6c757d;
            font-weight: 600;

            cursor: pointer;
            &:hover{
                background-color: #f4f1f8;
                color: #50276b;
            }
            &.active{
                color: #50276b;
                border-bottom: 2px solid #50276b;
            }
        }
    }


}

@media screen and (max-width: 1000px){
    .topbar{
        height:fit-content;
        .title{
            flex-direction: column;
            align-items: start;
            gap: 10px;
            
            h2{
                font-size: 1.5rem;
                margin-bottom: 10px;
            }
            .bg-8967b3{
                padding: 5px 10px;
                width: 100%;
            }
        }
        .tabs{
            margin-top: 2.5rem;
            .tab{
                padding: 5px 10px;
            }
        }
    }
}

</style>